var CoverVariables                = require("app/theme/styles/covers/CoverVariables"),
    FitableSupport                = require("enyo-ui/FitableSupport"),
    HyperLinkSupport              = require("enyo-ui/HyperLinkSupport"),
    Image                         = require("app/ui/Image"),
    ImageOptimizerSupport         = require("app/ui/ImageOptimizerSupport"),
    findBestFittingCover          = require("app/utils/findBestFittingCover"),
    findBestFittingPlaceholder    = require("app/utils/findBestFittingPlaceholder"),
    findBestFittingPremiumOverlay = require("app/utils/findBestFittingPremiumOverlay"),
    frameThrottle                 = require("enyo-perf/utils").frameThrottle,
    get                           = require("object-path").get,
    kind                          = require("enyo/kind"),
    onHyperlinkTap                = require("app/utils/onHyperlinkTap"),
    placeholders                  = require("app/theme/assets/placeholders-notext"),
    premiumOverlays               = require("app/theme/assets/premium-overlays"),
    quickMacroize                 = require("enyo/macroize").quickMacroize,
    utils                         = require("enyo/utils");

require("app/ui/covers/SimpleCover.less");

module.exports = kind(/** @lends  app.ui.covers.SimpleCover.prototype */ {

    /**
     * @private
     */
    name: "app.ui.covers.SimpleCover",

    /**
     * @private
     */
    classes: "app-ui-covers-simple-cover",

    /**
     * @private
     */
    mixins: [
        FitableSupport
    ],

    /**
     * @type     {string}
     * @default  "_self"
     * @public
     */
    target: "_self",

    /**
     * @type     {string}
     * @default  "follow"
     * @public
     */
    rel: "follow",

    /**
     * The form-factor of the cover.
     *
     * @type     {string=}
     * @default  null
     * @public
     */
    formFactor: null,

    /**
     * Whether to display a 'new' ribbon for new media items
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    showNewRibbon: true,

    /**
     * Whether to display a 'plan' ribbon for media items only available on
     * certain plans.
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    showPlanRibbon: true,

    /**
     * Whether to display a quality stamp on top of the image
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    showQualityStamp: true,

    /**
     * Whether to display a title below the image
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    showTitle: true,

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:    "imageWrapper",
        classes: "app-ui-covers-simple-cover__image-wrapper",
        mixins:  [
            HyperLinkSupport
        ],
        ontap:      "onHyperlinkTap",
        components: [{
            name:       "placeholder",
            kind:       Image,
            mixins:     [ImageOptimizerSupport],
            classes:    "app-ui-covers-simple-cover__placeholder",
            attributes: {
                loading:  "eager",
                decoding: "async"
            },
            canGenerate: Boolean(CoverVariables.usePlaceholderImage),

            /**
             * @returns  {Object}  The dimensions
             * @private
             */
            resolveImageDimensions: function() {
                return this.owner.calcImageDimensions();
            }
        }, {
            name:       "image",
            kind:       Image,
            mixins:     [ImageOptimizerSupport],
            classes:    "app-ui-covers-simple-cover__image",
            attributes: {
                loading:  "eager",
                decoding: "async"
            },

            /**
             * @returns  {Object}  The dimensions
             * @private
             */
            resolveImageDimensions: function() {
                return this.owner.calcImageDimensions();
            }
        }, {
            name:       "premiumOverlay",
            kind:       Image,
            mixins:     [ImageOptimizerSupport],
            classes:    "app-ui-covers-simple-cover__premium-overlay",
            attributes: {
                loading:  "eager",
                decoding: "sync"
            },
            imageOptimizerNoPng: false,

            /**
             * @returns  {Object}  The dimensions
             * @private
             */
            resolveImageDimensions: function() {
                return this.owner.calcImageDimensions();
            }
        }, {
            name:        "newRibbon",
            kind:        Image,
            classes:     "app-ui-covers-simple-cover__new-ribbon",
            canGenerate: false
        }, {
            name:        "planRibbon",
            kind:        Image,
            classes:     "app-ui-covers-simple-cover__plan-ribbon",
            canGenerate: false
        }, {
            name:        "qualityStamp",
            kind:        Image,
            src:         require("app/theme/assets/quality-stamp-top-left.png"),
            classes:     "app-ui-covers-simple-cover__quality-stamp",
            canGenerate: false
        }]
    }, {
        classes:    "app-ui-covers-simple-cover__title-bar",
        components: [{
            name:       "titleWrapper",
            classes:    "app-ui-covers-simple-cover__title-bar__title-wrapper",
            components: [{
                name:    "title",
                classes: "app-ui-covers-simple-cover__title-bar__title"
            }, {
                name:    "secondaryTitle",
                classes: "app-ui-covers-simple-cover__title-bar__secondary-title"
            }]
        }]
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".target",
        to:   ".$.imageWrapper.target"
    }, {
        from: ".rel",
        to:   ".$.imageWrapper.rel"
    }],

    /**
     * @private
     */
    observers: {
        update: ["formFactor", "data", "showNewRibbon", "showPlanRibbon", "showQualityStamp"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.formFactorChanged();
            this.showTitleChanged();
            this.update();
        };
    }),

    /**
     * @private
     */
    formFactorChanged: function() {
        var formFactor     = this.get("formFactor"),
            aspectRatio,
            placeholder    = null,
            premiumOverlay = null;

        if (formFactor) {
            aspectRatio    = CoverVariables.getAspectRatio(formFactor);
            placeholder    = CoverVariables.usePlaceholderImage
                ? findBestFittingPlaceholder(
                    placeholders,
                    aspectRatio
                )
                : null;
            premiumOverlay = findBestFittingPremiumOverlay(
                premiumOverlays,
                aspectRatio
            );
        }

        this.$.placeholder.set("rawImageSrc", placeholder ? {
            width:  placeholder.width || null,
            height: placeholder.height || null,
            ratio:  placeholder.aspect_ratio || null,
            src:    get(placeholder, "url", null)
        } : null);

        this.$.premiumOverlay.set("rawImageSrc", premiumOverlay ? {
            width:  premiumOverlay.width || null,
            height: premiumOverlay.height || null,
            ratio:  premiumOverlay.aspect_ratio || null,
            src:    get(premiumOverlay, "url", null)
        } : null);
    },

    /**
     * @private
     */
    showTitleChanged: function() {
        var showTitle = this.get("showTitle");

        // Title visibility
        if (showTitle) {
            !this.hasClass("has-title") && this.addClass("has-title");
        }
        else {
            while (this.hasClass("has-title")) {
                this.removeClass("has-title");
            }
        }
    },

    /**
     * Update the contents of the cover.
     *
     * @public
     */
    update: function() {
        var i18nService     = this.app.$.i18nService,
            language        = i18nService.get("language") || "",
            data            = this.data || {},
            formFactor      = this.get("formFactor"),
            cover           = formFactor ? findBestFittingCover(
                data,
                CoverVariables.getAspectRatio(formFactor)
            ) : null,
            plan            = get(data, "plan", null),
            title           = get(data, "meta.title", null) || "",
            secondaryTitle  = get(data, "meta.secondary_title", null),
            $titleWrapper   = this.$.titleWrapper,
            $title          = this.$.title,
            $secondaryTitle = this.$.secondaryTitle;

        this.$.premiumOverlay.hide();

        this.$.image.set("rawImageSrc", cover ? {
            width:  cover.width || null,
            height: cover.height || null,
            ratio:  cover.aspect_ratio || null,
            src:    get(cover, "url", null)
        } : null);

        this.$.planRibbon.set("src", language && plan ? quickMacroize("/img/plan-{$plan}-ribbon-top-right.{$language}.png?v={$v}", {
            plan:     plan,
            language: language,
            v:        BUILT_AT
        }) : null);

        this.$.newRibbon.set("src", language ? quickMacroize("/img/new-ribbon-top-left.{$language}.png?v={$v}", {
            language: language,
            v:        BUILT_AT
        }) : null);

        $title.set("content", title);

        if (secondaryTitle) {
            while ($titleWrapper.hasClass("no-secondary-title")) {
                $titleWrapper.removeClass("no-secondary-title");
            }
            $secondaryTitle.set("content", secondaryTitle);
            $secondaryTitle.show();
        }
        else {
            if (!$titleWrapper.hasClass("no-secondary-title")) {
                $titleWrapper.addClass("no-secondary-title");
            }
            $secondaryTitle.hide();
            $secondaryTitle.set("content", null);
        }

        // Visibility of various parts
        this.updateNewRibbonVisibility();
        this.updatePlanRibbonVisibility();
        this.updateQualityStampVisibility();
    },

    /**
     * Resolve the visibility of the new ribbon.
     *
     * @private
     */
    updateNewRibbonVisibility: function() {
        var data          = this.data || {},
            mediaType     = get(data, "type", null),
            isNew         = get(data, "is_recently_published", false),
            showNewRibbon = this.get("showNewRibbon"),
            themeFlag     = CoverVariables.getNewRibbonVisibility(mediaType),
            $newRibbon    = this.$.newRibbon;

        if (isNew && showNewRibbon && themeFlag) {
            $newRibbon.set("canGenerate", true);
            $newRibbon.render();
        }
        else {
            $newRibbon.removeNodeFromDom();
            $newRibbon.teardownRender();
            $newRibbon.set("canGenerate", false);
        }
    },

    /**
     * Resolve the visibility of the new ribbon.
     *
     * @private
     */
    updatePlanRibbonVisibility: function() {
        var data           = this.data || {},
            mediaType      = get(data, "type", null),
            plan           = get(data, "plan", null),
            showPlanRibbon = this.get("showPlanRibbon"),
            themeFlag      = CoverVariables.getPlanRibbonVisibility(mediaType, plan),
            $planRibbon    = this.$.planRibbon;

        if (plan && showPlanRibbon && themeFlag) {
            $planRibbon.set("canGenerate", true);
            $planRibbon.render();
        }
        else {
            $planRibbon.removeNodeFromDom();
            $planRibbon.teardownRender();
            $planRibbon.set("canGenerate", false);
        }
    },

    /**
     * Resolve the visibility of the quality stamp.
     *
     * @private
     */
    updateQualityStampVisibility: function() {
        var data             = this.data || {},
            qualityStamp     = get(data, "quality_stamp", false),
            isNew            = get(data, "is_recently_published", false),
            mediaType        = get(data, "type", null),
            showQualityStamp = this.get("showQualityStamp"),
            themeFlag        = CoverVariables.getQualityStampVisibility(mediaType),
            $qualityStamp    = this.$.qualityStamp;

        if (qualityStamp && !isNew && showQualityStamp && themeFlag) {
            $qualityStamp.set("canGenerate", true);
            $qualityStamp.render();
        }
        else {
            $qualityStamp.removeNodeFromDom();
            $qualityStamp.teardownRender();
            $qualityStamp.set("canGenerate", false);
        }
    },

    /**
     * Calculates the width.
     *
     * @param   {number}  height  The height
     * @return  {number}  The width.
     * @public
     */
    calcWidth: function(height) {
        var formFactor = this.get("formFactor"),
            aspectRatio;

        if (height === 0 || !formFactor) {
            return 0;
        }

        aspectRatio = CoverVariables.getAspectRatio(formFactor);

        if (!aspectRatio) {
            return 0;
        }

        if (this.showTitle) {
            return Math.round((height - CoverVariables.getTitleHeightPx()) * aspectRatio);
        }
        else {
            return Math.round(height * aspectRatio);
        }
    },

    /**
     * Calculates the height.
     *
     * @param   {number}  width  The width
     * @return  {number}  The height.
     * @public
     */
    calcHeight: function(width) {
        var formFactor = this.get("formFactor"),
            aspectRatio;

        if (width === 0 || !formFactor) {
            return 0;
        }

        aspectRatio = CoverVariables.getAspectRatio(formFactor);

        if (!aspectRatio) {
            return 0;
        }

        if (this.showTitle) {
            return Math.round(width / aspectRatio + CoverVariables.getTitleHeightPx());
        }
        else {
            return Math.round(width / aspectRatio);
        }
    },

    /**
     * Calculates the dimensions of the image.
     *
     * @returns  {Object}  The dimensions
     * @public
     */
    calcImageDimensions: function() {
        var formFactor = this.get("formFactor"),
            aspectRatio,
            bounds     = {};

        if (formFactor) {
            aspectRatio = CoverVariables.getAspectRatio(formFactor);

            bounds = this.get("repeaterBounds") || this.get("cachedBounds") || this.getBounds();
            bounds = utils.clone(bounds);
        }

        if (bounds.width && aspectRatio) {
            return {
                width:  Math.round(bounds.width),
                height: Math.round(bounds.width / aspectRatio)
            };
        }
        else if (bounds.height && aspectRatio) {
            if (this.showTitle) {
                bounds.height -= Math.round(CoverVariables.getTitleHeightPx());
            }

            return {
                height: Math.round(bounds.height),
                width:  Math.round(bounds.height * aspectRatio)
            };
        }
        else {
            return {
                width:  0,
                height: 0
            };
        }
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}       Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
